module.exports = __webpack_public_path__ + "public/img/Strategi Kompensasi dan Benefit Karyawan Untuk HR Payroll.4c84c820.png";